<template>
  <span class="revision-validity" v-if="fromStr || untilStr">
    <span class="revision-validity__from">
      {{fromStr || '∞'}}
    </span>
    <span class="revision-validity__separator">—</span>
    <span class="revision-validity__until">
      {{untilStr || '∞'}}
    </span>
  </span>
  <span class="revision-validity" v-else>∞</span>
</template>

<script>
export default {
  name: 'revision-validity',
  props: {
    from: String,
    until: String,
  },
  computed: {
    fromStr() {
      return this.formatDateTime(this.from);
    },
    untilStr() {
      return this.formatDateTime(this.until);
    },
  },
  methods: {
    formatDateTime(str) {
      if (!str) return null;
      const dateTime = new Date(str);
      return this.$d(dateTime);
    },
  },
};
</script>



// WEBPACK FOOTER //
// RevisionValidity.vue?056d15a8